import base64ToArrayBuffer from "common/script/base64ToArrayBuffer";
import ComunicazioniService from "services/API/Comunicazioni/ComunicazioniService";

async function download_pdf_allegato(idAllegato, nome_file) {
  ComunicazioniService.download_allegato(idAllegato)
      .then(response => {
 
        return response.data;
      })
      .then(blob => {

        var arrrayBuffer = base64ToArrayBuffer(blob); //data is the base64 encoded string
        var blobb = new Blob([arrrayBuffer], { type: "application/pdf" });
        var url = URL.createObjectURL(blobb);
        var a = document.createElement('a');
        a.href = url;
        a.target = "_blank";

        a.download = nome_file;
        ;

        document.body.appendChild(a); // append the element to the dom
        a.click();
        a.remove(); // afterwards, remove the element  
      })
      .catch(error => {
        console.error(error);
      });

}
export default download_pdf_allegato